import React, { useState } from 'react';
import { Row, Col, Button, Container, Form } from 'react-bootstrap';

import fireball from '../assets/images/fireball.svg';
import rocketIcon from '../assets/images/rocket-icon.svg';
import { submitContactForm } from '../services/apiService';
import websiteInfo from '../config/websiteInfo';

const ContactUs = () => {
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState({ type: '', text: '' });

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        purpose: '',
        budget: '',
        message: '',
        company: ''
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const newErrors = {};

        if (!formData.name.trim()) newErrors.name = "Name is required";

        if (!formData.company?.trim()) newErrors.company = "Company/Brand name is required";

        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
            newErrors.email = "Enter a valid email";
        }

        if (!formData.phone.trim()) {
            newErrors.phone = "Phone is required";
        } else if (!/^\d{10}$/.test(formData.phone)) {
            newErrors.phone = "Phone must be 10 digits";
        }

        if (!formData.purpose?.trim()) newErrors.purpose = "This field is required";

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        setIsSubmitting(true);
        setSubmitMessage({ type: '', text: '' });

        try {
            const response = await submitContactForm(formData);

            if (response.success) {
                setSubmitMessage({
                    type: 'success',
                    text: 'Thank you! Your message has been sent successfully. We will get back to you soon.'
                });
                // Reset form
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    subject: '',
                    purpose: '',
                    budget: '',
                    message: '',
                    company: ''
                });
                setErrors({});
                // Clear message after 5 seconds
                setTimeout(() => {
                    setSubmitMessage({ type: '', text: '' });
                }, 5000);
            } else {
                setSubmitMessage({
                    type: 'error',
                    text: response.error || 'Failed to send message. Please try again later.'
                });
            }
        } catch (error) {
            setSubmitMessage({
                type: 'error',
                text: 'An unexpected error occurred. Please try again later.'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className='contact-page'>


            <div className="position-relative">
                <img src={fireball} alt='floating-icons' className='floating-icons right' />
                <img src={rocketIcon} alt='floating-icons' className='floating-icons left bottom' />


                <Container className='pt-5 mt-5'>
                    <section className='pt-5'>
                        <Row>
                            {/* <Col md={2}>
                            <div className="title-pill">Contact Us</div>
                        </Col> */}
                            <Col md={10}>
                                <span className='text-white'>Contact Us</span>
                                <h1 className='outline-theme-text'>Let’s Launch Something Big.</h1>
                                <p className='text-light'>Tell us what you want to achieve — we’ll build the roadmap</p>
                            </Col>
                        </Row>
                    </section>
                </Container>


                {/* Contact Form Section */}
                <Container className='py-5'>
                    <div className='contact-form-section' style={{ position: 'relative' }}>
                        {/* Loading Overlay */}
                        {isSubmitting && (
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                zIndex: 1000,
                                borderRadius: '20px',
                                backdropFilter: 'blur(2px)'
                            }}>
                                <div className="text-center">
                                    <i className="fa-solid fa-spinner fa-spin text-white" style={{ fontSize: '2rem', marginBottom: '1rem' }}></i>
                                    <p className="text-white fs-14 mb-0">Sending your message...</p>
                                </div>
                            </div>
                        )}

                        <Row>
                            <Col lg={6} className='pe-lg-4'>
                                <Form onSubmit={handleSubmit} className='contact-form mb-5'>
                                    <Row>

                                        <Col lg={6}>
                                            <Form.Group className='mb-4'>
                                                <Form.Control
                                                    type='text'
                                                    name='name'
                                                    placeholder='Your Name'
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    className='form-input'
                                                />
                                                {errors.name && <p className="text-danger fs-13 mt-1">{errors.name}</p>}
                                            </Form.Group>
                                        </Col>

                                        <Col lg={6}>
                                            <Form.Group className='mb-4'>
                                                <Form.Control
                                                    type='text'
                                                    name='company'
                                                    placeholder='Your Brand Name / Company'
                                                    value={formData.company}
                                                    onChange={handleChange}
                                                    className='form-input'
                                                />
                                                {errors.company && <p className="text-danger fs-13 mt-1">{errors.company}</p>}
                                            </Form.Group>
                                        </Col>

                                        <Col lg={6}>
                                            <Form.Group className='mb-4'>
                                                <Form.Control
                                                    type='email'
                                                    name='email'
                                                    placeholder='Your Email'
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    className='form-input'
                                                />
                                                {errors.email && <p className="text-danger fs-13 mt-1">{errors.email}</p>}
                                            </Form.Group>
                                        </Col>

                                        <Col lg={6}>
                                            <Form.Group className='mb-4'>
                                                <Form.Control
                                                    type='tel'
                                                    name='phone'
                                                    placeholder='Your Phone'
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    className='form-input'
                                                />
                                                {errors.phone && <p className="text-danger fs-13 mt-1">{errors.phone}</p>}
                                            </Form.Group>
                                        </Col>


                                        <Col lg={12}>
                                            <Form.Group className='mb-4'>
                                                <Form.Control
                                                    type='text'
                                                    name='purpose'
                                                    placeholder='Your What are you looking for ?'
                                                    value={formData.purpose}
                                                    onChange={handleChange}
                                                    className='form-input'
                                                />
                                                {errors.purpose && <p className="text-danger fs-13 mt-1">{errors.purpose}</p>}
                                            </Form.Group>
                                        </Col>

                                        <Col lg={12}>
                                            <Form.Group className='mb-4'>
                                                <Form.Control
                                                    type='text'
                                                    name='budget'
                                                    placeholder='Project Budget (optional)'
                                                    value={formData.budget}
                                                    onChange={handleChange}
                                                    className='form-input'
                                                />

                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Form.Group className='mb-4'>
                                        <Form.Control
                                            as='textarea'
                                            rows={5}
                                            name='message'
                                            placeholder='Your Message'
                                            value={formData.message}
                                            onChange={handleChange}
                                            className='form-input'
                                        />
                                    </Form.Group>

                                    {/* Success/Error Message */}
                                    {submitMessage.text && (
                                        <div className={`mb-3 p-3 rounded ${submitMessage.type === 'success' ? 'text-success bg-success bg-opacity-10' : 'text-danger bg-danger bg-opacity-10'}`}>
                                            <p className="mb-0 fs-14">{submitMessage.text}</p>
                                        </div>
                                    )}

                                    <Button 
                                        variant='theme' 
                                        className='btn-rounded submit-btn' 
                                        type='submit'
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <span className='fs-14 fw-500 me-2'>Sending...</span>
                                                <i className="fa-solid fa-spinner fa-spin"></i>
                                            </>
                                        ) : (
                                            <>
                                                <span className='fs-14 fw-500'>Send Message</span>
                                                <span className='arrow-icon'>
                                                    <i className='fa-solid fa-arrow-right icon'></i>
                                                    <i className='fa-solid fa-arrow-right icon'></i>
                                                </span>
                                            </>
                                        )}
                                    </Button>
                                </Form>
                            </Col>
                            <Col lg={6}>
                                <iframe src={websiteInfo.maps.embedUrl} width="100%" height="510" style={{ border: 0, borderRadius: '40px' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </Col>
                        </Row>


                    </div>
                </Container >
            </div>

            {/* Address Cards Section */}
            <Container className='py-5 mb-5'>
                <div className='address-cards-section'>
                    <Row className='g-4'>
                        {/* Address Card */}
                        <Col lg={4} md={6}>
                            <div className='address-card h-100'>
                                <div className='card-icon'>
                                    <i className="fa-solid fa-map-marker-alt"></i>
                                </div>
                                <h6 className='card-title'>ADDRESS STUDIO</h6>
                                <p className='card-text'>{websiteInfo.address.full}</p>
                            </div>
                        </Col>

                        {/* Mail Card */}
                        <Col lg={4} md={6}>
                            <div className='address-card h-100'>
                                <div className='card-icon'>
                                    <i className="fa-solid fa-envelope"></i>
                                </div>
                                <h6 className='card-title'>MAIL SUPPORT 24/7</h6>
                                <div className='card-links'>
                                    {websiteInfo.contact.email.map((email, index) => (
                                        <a key={index} href={email.link}>{email.display}</a>
                                    ))}
                                </div>
                            </div>
                        </Col>

                        {/* Phone Card */}
                        <Col lg={4} md={6}>
                            <div className='address-card h-100'>
                                <div className='card-icon'>
                                    <i className="fa-solid fa-phone"></i>
                                </div>
                                <h6 className='card-title'>PHONE</h6>
                                <div className='card-links'>
                                    {websiteInfo.contact.phone.map((phone, index) => (
                                        <a key={index} href={phone.link}>{phone.display}</a>
                                    ))}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>

        </div >
    )
};

export default ContactUs;